export const NOTIFICATION_MESSAGES = {
  TAG_UPDATE_SUCCESS: '태그 업데이트 완료',
  TAG_UPDATE_SUCCESS_DESC: '태그가 성공적으로 업데이트되었습니다',
  TAG_UPDATE_ERROR: '태그 업데이트 실패',
  TAG_UPDATE_ERROR_DESC: '태그 정보를 저장하지 못했습니다. 다시 시도해 주세요',

  TERM_UPDATE_SUCCESS: '용어 업데이트 완료',
  TERM_UPDATE_SUCCESS_DESC: '용어가 성공적으로 업데이트되었습니다',
  TERM_UPDATE_ERROR: '용어 업데이트 실패',
  TERM_UPDATE_ERROR_DESC: '용어 업데이트 중 오류가 발생했습니다',

  OWNER_UPDATE_SUCCESS: '소유자 업데이트 완료',
  OWNER_UPDATE_SUCCESS_DESC: '소유자가 성공적으로 업데이트되었습니다',
  OWNER_UPDATE_ERROR: '소유자 업데이트 실패',
  OWNER_UPDATE_ERROR_DESC: '소유자 업데이트 중 오류가 발생했습니다',

  EXPERT_UPDATE_SUCCESS: '전문가 업데이트 완료',
  EXPERT_UPDATE_SUCCESS_DESC: '전문가가 성공적으로 업데이트되었습니다',
  EXPERT_UPDATE_ERROR: '전문가 업데이트 실패',
  EXPERT_UPDATE_ERROR_DESC: '전문가 업데이트 중 오류가 발생했습니다',

  DESCRIPTION_UPDATE_SUCCESS: '설명 업데이트 완료',
  DESCRIPTION_UPDATE_SUCCESS_DESC: '설명이 성공적으로 업데이트되었습니다',
  DESCRIPTION_UPDATE_ERROR: '설명 업데이트 실패',
  DESCRIPTION_UPDATE_ERROR_DESC: '설명 업데이트 중 오류가 발생했습니다',

  DOMAIN_TYPE_UPDATE_SUCCESS: '도메인 유형 업데이트 완료',
  DOMAIN_TYPE_UPDATE_SUCCESS_DESC: '도메인 유형이 성공적으로 업데이트되었습니다',
  DOMAIN_TYPE_UPDATE_ERROR: '도메인 유형 업데이트 실패',
  DOMAIN_TYPE_UPDATE_ERROR_DESC: '도메인 유형 업데이트 중 오류가 발생했습니다',

  DOMAIN_UPDATE_SUCCESS: '도메인 업데이트 완료',
  DOMAIN_UPDATE_SUCCESS_DESC: '도메인이 성공적으로 업데이트되었습니다',
  DOMAIN_UPDATE_ERROR: '도메인 업데이트 실패',
  DOMAIN_UPDATE_ERROR_DESC: '도메인 업데이트 중 오류가 발생했습니다',

  DOMAIN_CATEGORY_ERROR: '도메인 유형 불러오기 실패',
  DOMAIN_CATEGORY_ERROR_DESC: '도메인 유형을 불러오는 중 문제가 발생했습니다. 다시 시도해 주세요',

  DOMAIN_DETAIL_ERROR: '도메인 상세 정보 불러오기 실패',
  DOMAIN_DETAIL_ERROR_DESC: '도메인 상세 정보를 불러오는 중 문제가 발생했습니다. 다시 시도해 주세요',

  DATA_ASSETS_OVERVIEW_ERROR: '자산 현황 불러오기 실패',
  DATA_ASSETS_OVERVIEW_ERROR_DESC: '자산 현황을 불러오지 못했습니다. 다시 시도해 주세요',

  TAG_DISTRIBUTION_ERROR: '태그별 자산 정보 불러오기 실패',
  TAG_DISTRIBUTION_ERROR_DESC: '태그별 자산 정보를 불러오지 못했습니다. 다시 시도해 주세요',

  RECENT_ASSETS_ERROR: '최근 본 항목 불러오기 실패',
  RECENT_ASSETS_ERROR_DESC: '최근 본 항목을 불러오지 못했습니다. 다시 시도해 주세요',

  FAVORITES_ERROR: '즐겨찾기 불러오기 실패',
  FAVORITES_ERROR_DESC: '즐겨찾기 정보를 불러오지 못했습니다. 다시 시도해 주세요',

  MY_ASSETS_ERROR: '최근 변경된 자산 불러오기 실패',
  MY_ASSETS_ERROR_DESC: '최근 변경된 자산을 불러오지 못했습니다. 다시 시도해 주세요',

  DATA_SERVICES_ERROR: '소스별 자산 불러오기 실패',
  DATA_SERVICES_ERROR_DESC: '소스별 자산 정보를 불러오지 못했습니다. 다시 시도해 주세요',

  DOMAIN_TREE_ERROR: '도메인 카테고리 오류',
  DOMAIN_TREE_ERROR_DESC: '데이터를 불러오지 못했습니다. 다시 시도해 주세요',
  DOMAIN_TREE_ONLY_ONE_SELECT: '도메인을 하나만 선택할 수 있습니다',
  DOMAIN_TREE_UPDATE_ERROR: '도메인 카테고리 업데이트 실패',
  DOMAIN_TREE_UPDATE_ERROR_DESC: '도메인 정보를 저장하지 못했습니다. 다시 시도해 주세요',

  GLOSSARY_CATEGORY_COMPONENT_ERROR: '용어사전 카테고리 오류',
  GLOSSARY_CATEGORY_COMPONENT_ERROR_DESC: '데이터를 불러오지 못했습니다. 다시 시도해 주세요',

  GLOSSARY_CATEGORY_ERROR: '용어 카테고리 불러오기 실패',
  GLOSSARY_CATEGORY_ERROR_DESC: '용어 카테고리를 불러오는 중 문제가 발생했습니다. 다시 시도해 주세요',

  GLOSSARY_DETAIL_COMPONENT_ERROR: '용어사전 상세 정보 오류',
  GLOSSARY_DETAIL_COMPONENT_ERROR_DESC: '데이터를 불러오지 못했습니다. 다시 시도해 주세요',

  TAGS_COMPONENT_ERROR: '태그 카테고리 오류',
  TAGS_COMPONENT_ERROR_DESC: '데이터를 불러오지 못했습니다. 다시 시도해 주세요',

  TAGS_DETAIL_COMPONENT_ERROR: '태그 카테고리 오류',
  TAGS_DETAIL_COMPONENT_ERROR_DESC: '데이터를 불러오지 못했습니다. 다시 시도해 주세요',

  SYNONYM_UPDATE_SUCCESS: '동의어 업데이트 완료',
  SYNONYM_UPDATE_SUCCESS_DESC: '동의어가 성공적으로 업데이트되었습니다',
  SYNONYM_UPDATE_ERROR: '동의어 업데이트 실패',
  SYNONYM_UPDATE_ERROR_DESC: '동의어 업데이트 중 오류가 발생했습니다',

  GLOSSARY_TERM_CREATE_SUCCESS: '용어가 성공적으로 생성되었습니다',
  GLOSSARY_TERM_UPDATE_SUCCESS: '용어가 성공적으로 수정되었습니다',
  GLOSSARY_TERM_DELETE_SUCCESS: '용어가 성공적으로 삭제되었습니다',

  GLOSSARY_CATEGORY_CREATE_SUCCESS: '용어집이 성공적으로 생성되었습니다',
  GLOSSARY_CATEGORY_UPDATE_SUCCESS: '용어집이 성공적으로 수정되었습니다',
  GLOSSARY_CATEGORY_DELETE_SUCCESS: '용어집이 성공적으로 삭제되었습니다',

  DOMAIN_CREATE_SUCCESS: '도메인이 생성되었습니다',
  DOMAIN_CREATE_SUCCESS_DESC: '새 도메인이 성공적으로 생성되었습니다',
  DOMAIN_DELETE_SUCCESS: '도메인이 삭제되었습니다',
  DOMAIN_DELETE_SUCCESS_DESC: '도메인이 성공적으로 삭제되었습니다',

  TAG_CREATE_SUCCESS: '태그가 생성되었습니다',
  TAG_CREATE_SUCCESS_DESC: '새 태그가 성공적으로 생성되었습니다',
  TAG_DELETE_SUCCESS: '태그가 삭제되었습니다',
  TAG_DELETE_SUCCESS_DESC: '태그가 성공적으로 삭제되었습니다',

  CLASSIFICATION_CREATE_SUCCESS: '분류가 생성되었습니다',
  CLASSIFICATION_CREATE_SUCCESS_DESC: '새 분류가 성공적으로 생성되었습니다',
  CLASSIFICATION_UPDATE_SUCCESS: '분류가 수정되었습니다',
  CLASSIFICATION_UPDATE_SUCCESS_DESC: '분류가 성공적으로 수정되었습니다',
  CLASSIFICATION_DELETE_SUCCESS: '분류가 삭제되었습니다',
  CLASSIFICATION_DELETE_SUCCESS_DESC: '분류가 성공적으로 삭제되었습니다',

  CONNECTOR_CREATE_SUCCESS_DESC: '커넥터가 성공적으로 생성되었습니다.',
  CONNECTOR_NAME_CONFLICT_DESC: '이미 존재하는 커넥터 이름입니다. 다른 이름을 입력해 주세요',
  CONNECTOR_FORM_ERROR: 'Connecting Failed',

  CONNECTOR_DELETE_ERROR_DESC: '커넥터 삭제 중 오류가 발생했습니다. 다시 시도해주세요.',
  CONNECTOR_DELETE_ALL_SUCCESS_DESC: '선택한 커넥터가 성공적으로 삭제되었습니다.',
  CONNECTOR_LIST_ERROR: '커넥터 목록 조회 실패',
  CONNECTOR_LIST_ERROR_DESC: '커넥터 목록 조회 중 오류가 발생했습니다. 다시 시도해주세요.',
  CONNECTOR_TYPE_SELECTION_ERROR: '커넥터 타입 목록 조회 실패',
  CONNECTOR_TYPE_SELECTION_ERROR_DESC: '커넥터 타입 목록을 불러오는 중 오류가 발생했습니다.',
  CONNECTOR_TEST_SUCCESS: '연결 테스트 성공',
  CONNECTOR_TEST_SUCCESS_DESC: '커넥터 연결이 정상적으로 확인되었습니다.',
  CONNECTOR_TEST_ERROR: '연결 테스트 실패',
  CONNECTOR_TEST_ERROR_DESC: '커넥터 연결에 실패했습니다.',
  CONNECTOR_UPDATE_SUCCESS: '커넥터 수정 완료',
  CONNECTOR_UPDATE_SUCCESS_DESC: '커넥터 정보가 성공적으로 수정되었습니다.',
  CONNECTOR_STATUS_UPDATE_SUCCESS: '상태 변경 완료',
  CONNECTOR_STATUS_UPDATE_SUCCESS_DESC: '커넥터 상태가 성공적으로 변경되었습니다.',
  CONNECTOR_STATUS_UPDATE_ERROR_DESC: '커넥터 상태 변경 중 오류가 발생했습니다. 다시 시도해주세요.',
  CONNECTOR_STATUS_UPDATE_ALL_SUCCESS: '커넥터 상태 일괄 변경 완료',
  CONNECTOR_STATUS_UPDATE_ALL_SUCCESS_DESC: '선택한 커넥터 상태가 성공적으로 변경되었습니다.',
  DAG_CREATE_SUCCESS_DESC: 'DAG가 성공적으로 생성되었습니다.',
  DAG_CREATE_ERROR_DESC: 'DAG 생성 중 오류가 발생했습니다. 다시 시도해주세요.',

  DAG_LIST_ERROR: 'Airflow DAG 목록을 불러오지 못했습니다',
  DAG_DETAIL_ERROR: 'DAG 상세 정보를 불러올 수 없습니다',
  DAG_DETAIL_ERROR_DESC: '잘못된 경로이거나 DAG가 존재하지 않습니다. 경로를 확인하거나 DAG 목록으로 돌아가세요.',
  DAG_DELETE_SUCCESS: 'DAG 삭제 완료',
  DAG_DELETE_SUCCESS_DESC: 'DAG가 성공적으로 삭제되었습니다.',
  DAG_DELETE_ERROR: 'DAG 삭제 실패',
  DAG_DELETE_ERROR_DESC: 'DAG 삭제 중 오류가 발생했습니다. 다시 시도해주세요.',
  DAG_UPDATE_SUCCESS: 'DAG 수정 완료',
  DAG_UPDATE_SUCCESS_DESC: 'DAG 정보가 성공적으로 수정되었습니다.',
  DAG_UPDATE_ERROR: 'DAG 수정 실패',
  DAG_UPDATE_ERROR_DESC: 'DAG 정보 수정 중 오류가 발생했습니다. 다시 시도해주세요.',
  DAG_BOOKMARK_UPDATE_SUCCESS: 'DAG 즐겨찾기 변경 완료',
  DAG_BOOKMARK_UPDATE_SUCCESS_DESC: 'DAG 즐겨찾기 상태가 성공적으로 변경되었습니다.',
  DAG_BOOKMARK_UPDATE_ERROR: 'DAG 즐겨찾기 변경 실패',
  DAG_BOOKMARK_UPDATE_ERROR_DESC: 'DAG 즐겨찾기 상태 변경 중 오류가 발생했습니다. 다시 시도해주세요.',
  DAG_STATUS_UPDATE_SUCCESS: 'DAG 상태 변경 완료',
  DAG_STATUS_UPDATE_SUCCESS_DESC: 'DAG 실행 상태가 성공적으로 변경되었습니다.',
  DAG_STATUS_UPDATE_ERROR: 'DAG 상태 변경 실패',
  DAG_STATUS_UPDATE_ERROR_DESC: 'DAG 실행 상태 변경 중 오류가 발생했습니다. 다시 시도해주세요.',
  DAG_TRIGGER_SUCCESS: 'DAG 트리거 완료',
  DAG_TRIGGER_SUCCESS_DESC: 'DAG가 성공적으로 트리거되었습니다.',
  DAG_TRIGGER_ERROR: 'DAG 트리거 실패',
  DAG_TRIGGER_ERROR_DESC: 'DAG 트리거 중 오류가 발생했습니다. 다시 시도해주세요.',
  DAG_TRIGGER_TEMP_INFO: '트리거 기능 준비 중',
  DAG_TRIGGER_TEMP_INFO_DESC: '현재는 임시 동작입니다. 실제 트리거는 추후 연결됩니다.',
  DAG_CODE_SAVE_SUCCESS: '새 버전 저장 완료',
  DAG_CODE_SAVE_SUCCESS_DESC: '버전이 성공적으로 저장되었습니다.',
  DAG_CODE_SAVE_ERROR: '새 버전 저장 실패',
  DAG_CODE_SAVE_ERROR_DESC: '코드 버전 저장 중 오류가 발생했습니다. 다시 시도해주세요.',
  DAG_CODE_SAVE_TEMP_INFO: '신규 버전 저장 기능 준비 중',
  DAG_CODE_SAVE_TEMP_INFO_DESC: '현재는 임시 동작입니다. 실제 저장과 버전 생성은 추후 연결됩니다.',
  DAG_CODE_DEPLOY_SUCCESS: '배포 완료',
  DAG_CODE_DEPLOY_SUCCESS_DESC: '버전이 성공적으로 배포되었습니다.',
  DAG_CODE_DEPLOY_ERROR: '배포 실패',
  DAG_CODE_DEPLOY_ERROR_DESC: '배포 중 오류가 발생했습니다. 다시 시도해주세요.',
  DAG_CODE_DEPLOY_TEMP_INFO: '배포 기능 준비 중',
  DAG_CODE_DEPLOY_TEMP_INFO_DESC: '현재는 임시 동작입니다. 실제 배포는 추후 연결됩니다.',
  DAG_CODE_VERSION_FETCH_API_FAILED_LOG: '코드 조회 API 요청에 실패했습니다.',
  DAG_CODE_TRIGGER_API_FAILED_LOG: '트리거 API 요청에 실패했습니다.',
  DAG_CODE_TRIGGER_PREPARE_FAILED_LOG: '트리거 준비 과정에서 실패했습니다.',
  DAG_CODE_SAVE_API_FAILED_LOG: '저장 API 요청에 실패했습니다.',
  DAG_CODE_SAVE_PREPARE_FAILED_LOG: '저장 준비 과정에서 실패했습니다.',
  DAG_CODE_DEPLOY_API_FAILED_LOG: '배포 API 요청에 실패했습니다.',
  DAG_CODE_INITIAL_TASK_LOG_FETCH_FAILED_LOG: '실행 초기 로그를 불러오지 못했습니다.',

  DATA_ZONE_COUNT_ERROR_DESC: '데이터 적재 개수 데이터를 불러오는 중 오류가 발생했습니다',
  DATA_TEST_CASE_RESULTS_ERROR_DESC: '신규 데이터 품질 현황 데이터를 불러오는 중 오류가 발생했습니다',
  DATA_ZONE_LOAD_STATUS_ERROR_DESC: '데이터 적재 상태 데이터를 불러오는 중 오류가 발생했습니다',
  DATA_ASSET_QUALITY_ERROR_DESC: '자산별 품질 상세 데이터를 불러오는 중 오류가 발생했습니다',

  EXPERIMENT_DETAIL_ERROR: '실험 상세 정보 불러오기 실패',
  EXPERIMENT_DETAIL_ERROR_DESC: '실험 상세 정보를 불러오는 중 문제가 발생했습니다. 다시 시도해 주세요',

  EXPERIMENT_ID_MISSING_ERROR: 'URL에 실험 ID가 누락되었습니다',
  EXPERIMENT_DATA_NOT_FOUND_ERROR: '실험 데이터를 찾을 수 없습니다',

  EXPERIMENT_CREATE_SUCCESS: '실험 생성 완료',
  EXPERIMENT_CREATE_SUCCESS_DESC: '실험이 성공적으로 생성되었습니다.',
  EXPERIMENT_CREATE_ERROR: '실험 생성 실패',
  EXPERIMENT_CREATE_ERROR_DESC: '실험 생성 중 오류가 발생했습니다. 다시 시도해주세요.',

  EXPERIMENT_DELETE_SUCCESS: '실험 삭제 완료',
  EXPERIMENT_DELETE_ERROR: '실험 삭제 실패',
  EXPERIMENT_DELETE_ERROR_DESC: '실험 삭제 중 오류가 발생했습니다. 다시 시도해주세요.',

  RUN_ID_MISSING_ERROR: 'Run ID가 필요합니다',
  RUN_DATA_NOT_FOUND_ERROR: 'Run 데이터를 찾을 수 없습니다',
  RUN_DESCRIPTION_UPDATE_SUCCESS: '설명 수정 완료',
  RUN_DESCRIPTION_UPDATE_SUCCESS_DESC: '런 설명이 성공적으로 수정되었습니다.',
  RUN_DESCRIPTION_UPDATE_ERROR: '설명 수정 실패',
  RUN_DESCRIPTION_UPDATE_ERROR_DESC: '런 설명 수정 중 오류가 발생했습니다. 다시 시도해주세요.',

  MODEL_CREATE_SUCCESS: '모델 생성 성공',
  MODEL_CREATE_SUCCESS_DESC: '모델이 성공적으로 생성되었습니다.',
  MODEL_CREATE_ERROR: '모델 생성 실패',
  MODEL_CREATE_ERROR_DESC: '모델 생성 중 오류가 발생했습니다.',

  ASSET_DETAIL_FETCH_ERROR: 'Asset 조회 실패',
  ASSET_DETAIL_FETCH_ERROR_DESC: 'Asset 정보를 불러오는데 실패했습니다.',

  RUN_SUB_ASSETS_FETCH_ERROR: 'Run 서브 애셋 로딩 실패',
  RUN_SUB_ASSETS_FETCH_ERROR_DESC: 'Run의 서브 애셋을 불러오는데 실패했습니다.',

  EXPERIMENT_RUNS_FETCH_ERROR: '런 목록 로딩 실패',
  EXPERIMENT_RUNS_FETCH_ERROR_DESC: '실험의 런 목록을 불러오는데 실패했습니다.',
} as const;

export const EMPTY_MESSAGES = {
  NO_OWNERS: '소유자가 없습니다',
  NO_TAGS: '태그가 없습니다',
  NO_CATEGORY_TAG: '등록된 태그가 없습니다',
  NO_DOMAIN: '도메인이 없습니다',
  NO_DOMAIN_TREE_SELECT: '선택된 도메인이 없습니다',
  NO_CATEGORY: '상세 정보가 없습니다',
  NO_DATA: '표시할 항목이 없습니다',
  NO_SEARCH_RESULTS: '검색 결과가 없습니다',
  NO_FILTER_RESULTS: '현재 필터 조건에 맞는 결과가 없습니다',
  NO_DOMAIN_PRODUCTS: '이 도메인에 속한 데이터 제품이 없습니다',

  NO_GLOSSARY: '등록된 용어가 없습니다',
  NO_GLOSSARY_CATEGORY: '등록된 용어사전이 없습니다',
  NO_EXPERIMENTS: '등록된 실험이 없습니다',
  NO_EXPERIMENT_RUNS: '등록된 런이 없습니다',

  NO_CONNECTED_TAGS: '연결된 태그가 없습니다',
  NO_CONNECTED_TERMS: '연결된 용어가 없음',
  NO_REGISTERED_MODELS: '등록된 모델이 없습니다',
  NO_DATASETS: '데이터셋이 없습니다',

  NO_TEAMS: '팀이 없습니다',
  NO_USERS: '사용자가 없습니다',
  NO_EXPERTS: '전문가가 없습니다',
  NO_CERTIFICATION: '성숙도가 없습니다',
  NO_DOMAIN_TYPE: '도메인 유형이 없습니다',
  NO_TIER: '중요 등급이 없습니다',
  NO_CONNECTORS: '등록된 커넥터가 없습니다',
  NO_CONNECTOR_TYPES: '선택 가능한 커넥터 타입이 없습니다',
  NO_DAGS: 'DAG 목록이 없습니다',
  NO_DAG_RUN_HISTORY: '실행 기록이 없습니다',
  NO_DAG_STRUCTURE_GRAPH: 'DAG 구조 그래프가 없습니다',
  NO_DAG_RUN_RECORDS: '실행 기록이 없습니다',
  NO_DAG_VERSIONS: '버전이 없습니다',
  NO_DAG_DATA_SOURCES: '선택 가능한 데이터 소스가 없습니다',
  NO_DAG_TAG_OPTIONS: '선택 가능한 태그가 없습니다',
  NO_DAG_TASKS: '작업 목록이 없습니다',

  NO_ASSETS: '자산이 없습니다',
  NO_CONNECTED_ASSETS: '연결된 데이터 자산이 없습니다',
  NO_SELECTED_ITEM: '선택된 항목이 없습니다',
  NO_TABLE_ITEMS: '등록된 항목이 없습니다',
} as const;

export const PLACEHOLDER_MESSAGES = {
  OWNER_SELECT: '소유자를 선택하세요',
  TAG_SELECT: '태그를 선택하세요',
  TAG_SEARCH: '태그 검색...',
  DOMAIN_SELECT: '도메인을 선택하세요',
  DOMAIN_SEARCH: '도메인 검색...',
  DOMAIN_TREE_PLACEHOLDER: '도메인을 선택하세요',
  GLOSSARY_SELECT: '용어를 선택하세요',
  GLOSSARY_SEARCH: '용어 검색...',
  EXPERIMENT_SEARCH: '실험 검색...',
  RUN_SEARCH: '런 검색...',
} as const;

export const ACTION_LABELS = {
  RESET_FILTERS: '필터 초기화',
  RETRY: '다시 시도',
  REFRESH: '새로고침',
  GO_BACK: '뒤로가기',
} as const;
